import { useLocation } from "react-router-dom";
import { AppShell } from "@/components/layout/AppShell";
import { ErrorBoundary } from "@/app/ErrorBoundary";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  return (
    <AppShell>
      <ErrorBoundary resetKey={location.pathname}>{children}</ErrorBoundary>
    </AppShell>
  );
}
